import { Box } from '@chakra-ui/react';

import GradientTooltip from './GradientTooltip';
import Text from './Text';

interface FeatureTooltipProps {
  label: string;
}

const FeatureTooltip = ({ label }: FeatureTooltipProps) => (
  <GradientTooltip
    label={
      <Text fontSize="micro" opacity="secondary">
        {label}
      </Text>
    }
    placement="bottom"
  >
    <Box
      as="span"
      display="inline-flex"
      alignItems="center"
      justifyContent="center"
      w="16px"
      h="16px"
      borderRadius="full"
      bg="whiteAlpha.100"
      borderWidth={1}
      borderColor="whiteAlpha.200"
      cursor="help"
      _hover={{ bg: 'whiteAlpha.200', borderColor: 'whiteAlpha.300' }}
      transition="all 0.15s"
      ml={1}
    >
      <Text style={{ fontSize: '10px', lineHeight: 1 }} opacity="secondary">
        ?
      </Text>
    </Box>
  </GradientTooltip>
);

export default FeatureTooltip;
